import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import 'gw-capability-quoteandbind-PremierEL-react';
import 'gw-capability-policychange-common-react';
import 'premier-capability-policychange-common-react';
import ELPolicyChangesPage from './pages/ELPolicyChanges/ELPolicyChangesPage';

setComponentMapOverrides(
    {
        PremierELPolicyChangesPage: { component: 'PremierELPolicyChangesPage' }
    },
    {
        PremierELPolicyChangesPage: ELPolicyChangesPage
    }
);

export { default as PremierELPolicyChangeWizard } from './PremierELPolicyChangeWizard';
